// extracted by mini-css-extract-plugin
module.exports = {"content":"cartDrawer_content__6SP3Y","tailSpacer":"cartDrawer_tailSpacer__mUH5I","emptyMessage":"cartDrawer_emptyMessage__W6NEn","giftNotice":"cartDrawer_giftNotice__EY5_W"};